import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", this.enforceHierarchy.bind(this));
    });
  }

  enforceHierarchy(event) {
    const [read, edit, destroy] = this.checkboxTargets;
    const changed = event.target;

    if (changed.checked) {
      if (changed === edit) read.checked = true;
      if (changed === destroy) {
        read.checked = true;
        edit.checked = true;
      }
    } else {
      if (changed === read) {
        edit.checked = false;
        destroy.checked = false;
      }
      if (changed === edit) {
        destroy.checked = false;
      }
    }
  }
}
